// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gy-a";
export var fulfillmentFormRail = "_gy-9";
export var headerTitleRow = "_gy-c";
export var orderDetailsWrapper = "_gy-7";
export var orderLinkTrigger = "_gy-2";
export var paymentInformationGrid = "_gy-h";
export var paymentSummaryColumn = "_gy-i";
export var shipmentContainer = "_gy-b";
export var shipmentDetailsMainPane = "_gy-8";
export var shipmentNavigationCard = "_gy-5";
export var shipmentNavigationRail = "_gy-3";
export var shipmentNavigationRailHeader = "_gy-4";
export var shipmentSummaryFact = "_gy-e";
export var shipmentSummaryGrid = "_gy-d";
export var shipmentSummaryMetadataRow = "_gy-f";
export var shipmentSummaryTags = "_gy-g";
export var shipmentWorkspace = "_gy-0";
export var shipmentWorkspaceContent = "_gy-6";
export var shipmentWorkspaceHeader = "_gy-1";